import * as React from "react"
import { User, LoginState } from "./portal/state";
import { Action } from "widgets-for-react";
import { State, ExtraUserInfo } from "./portal_client";
import i18next = require("i18next");

type CounterProps = {
  user: () => User<ExtraUserInfo>,
  setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void,
  state: LoginState<State, ExtraUserInfo>,
  handleDecrease: () => void,
  handleIncrease: () => void,
  isDisabled: boolean,
  label: number,
}

export const Counter: React.StatelessComponent<CounterProps> = (props: CounterProps) => (
  <div className="counter">
    <button
      type="button"
      className="counter__button button--icon"
      aria-controls="a11y-current-product-count"
      disabled={props.isDisabled}
      onClick={props.handleDecrease}
    >
      <span className="sr-text">{i18next.t('quotation_request:counter.decrease')}</span>
      <svg className="button__icon" width="16px" height="16px" aria-hidden="true">
        <use xlinkHref="#icon--dash" />
      </svg>
    </button>

    <span className="counter__label" id="a11y-current-product-count" aria-label="Current amount">
      {props.label}
    </span>

    <button
      type="button"
      className="counter__button button--icon"
      aria-controls="a11y-current-product-count"
      onClick={props.handleIncrease}
    >
      <span className="sr-text">{i18next.t('quotation_request:counter.increase')}</span>
      <svg className="button__icon" width="16px" height="16px" aria-hidden="true">
        <use xlinkHref="#icon--plus" />
      </svg>
    </button>
  </div>
)
